export function getLabel(stages) {
  if (stages.length === 0) {
    return 'Stage'
  } else if (stages.length === 1) {
    return stages.map(stage => stage.name)
  } else {
    return `${stages.length} stages`
  }
}
